import { useState } from "react";
import { Link } from "react-router-dom";
import "./nav.css";
import { AiOutlineHome } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { SiExpertsexchange } from "react-icons/si";
import { RiServiceLine } from "react-icons/ri";
import { TiContacts } from "react-icons/ti";
import { ImBriefcase } from "react-icons/im";

const Nav = () => {
  const [activeNav, setActiveNav] = useState("#");

  // Função para verificar se estamos na página inicial
  const isHomePage = window.location.pathname === "/";

  // Se não estamos na página inicial, renderizamos links para a página inicial com âncoras
  if (!isHomePage) {
    return (
      <nav>
        <Link
          to="/"
          onClick={() => setActiveNav("#")}
          className={activeNav === "#" ? "active" : ""}
        >
          <AiOutlineHome />
        </Link>
        <Link
          to="/#about"
          onClick={() => setActiveNav("#about")}
          className={activeNav === "#about" ? "active" : ""}
        >
          <AiOutlineUser />
        </Link>
        <Link
          to="/#experience"
          onClick={() => setActiveNav("#experience")}
          className={activeNav === "#experience" ? "active" : ""}
        >
          <SiExpertsexchange />
        </Link>
        <Link
          to="/#services"
          onClick={() => setActiveNav("#services")}
          className={activeNav === "#services" ? "active" : ""}
        >
          <RiServiceLine />
        </Link>
        <Link
          to="/#portfolio"
          onClick={() => setActiveNav("#portfolio")}
          className={activeNav === "#portfolio" ? "active" : ""}
        >
          <ImBriefcase />
        </Link>
        <Link
          to="/#contact"
          onClick={() => setActiveNav("#contact")}
          className={activeNav === "#contact" ? "active" : ""}
        >
          <TiContacts />
        </Link>
      </nav>
    );
  }

  // Se estamos na página inicial, usamos âncoras normais para navegação suave
  return (
    <nav>
      <a
        href="#"
        onClick={() => setActiveNav("#")}
        className={activeNav === "#" ? "active" : ""}
      >
        <AiOutlineHome />
      </a>
      <a
        href="#about"
        onClick={() => setActiveNav("#about")}
        className={activeNav === "#about" ? "active" : ""}
      >
        <AiOutlineUser />
      </a>
      <a
        href="#experience"
        onClick={() => setActiveNav("#experience")}
        className={activeNav === "#experience" ? "active" : ""}
      >
        <SiExpertsexchange />
      </a>
      <a
        href="#services"
        onClick={() => setActiveNav("#services")}
        className={activeNav === "#services" ? "active" : ""}
      >
        <RiServiceLine />
      </a>
      <a
        href="#portfolio"
        onClick={() => setActiveNav("#portfolio")}
        className={activeNav === "#portfolio" ? "active" : ""}
      >
        <ImBriefcase />
      </a>
      <a
        href="#contact"
        onClick={() => setActiveNav("#contact")}
        className={activeNav === "#contact" ? "active" : ""}
      >
        <TiContacts />
      </a>
    </nav>
  );
};

export default Nav;
